// extracted by mini-css-extract-plugin
export var attribution = "_bn-4";
export var authorName = "_bn-5";
export var quote = "_bn-3";
export var testimonial = "_bn-2";
export var trustedBy = "_bn-0";
export var trustedByLabel = "_bn-1";